export default {
  'nav.tours': 'Tour trọn gói',
  'nav.specialServices': 'Dịch vụ đặc biệt',
  'nav.blog': 'Blog',
  'nav.about': 'Về chúng tôi',
  'nav.whyUs': 'Vì sao chọn chúng tôi',
  'nav.contact': 'Liên hệ',
  'nav.admin': 'Quản trị',
  'nav.adminPanel': 'Bảng quản trị',
  'nav.signIn': 'Đăng nhập',
  'nav.myAccount': 'Tài khoản',
  'nav.savedTours': 'Tour đã lưu',
  'nav.savedToursAria': 'Tour đã lưu: {{count}}',
  'search.title': 'Tìm kiếm',
  'search.placeholder': 'Tìm tour, điểm đến, trải nghiệm, bài viết...',
  'search.close': 'Đóng tìm kiếm',
  'search.startTyping': 'Bắt đầu gõ để tìm kiếm trên toàn bộ trang',
  'search.noResults': 'Không tìm thấy kết quả nào cho "{{query}}"',
  'search.tours': 'Tour trọn gói',
  'search.destinations': 'Điểm đến',
  'search.experiences': 'Trải nghiệm',
  'search.blog': 'Blog',
  'search.viewAll': 'Xem tất cả kết quả',
  'search.popular': 'Gợi ý phổ biến',
  'footer.licensedVerified': 'Được cấp phép & xác minh',
  'footer.officialTourOperator': 'Đơn vị lữ hành chính thức',
  'footer.company': 'Công ty',
  'footer.licenseNo': 'Số giấy phép',
  'footer.headquarters': 'Trụ sở chính',
  'footer.verified': 'Đã xác minh',
  'footer.licensed': 'Được cấp phép',
  'footer.intlOperator': 'Lữ hành quốc tế',
  'footer.contact': 'Liên hệ',
  'floating.callUs': 'Gọi cho chúng tôi',
  'floating.email': 'Email',
  'floating.whatsapp': 'WhatsApp',
  'floating.messenger': 'Messenger',
  'floating.chatInstantly': 'Nhắn tin ngay',
  'floating.fbChat': 'Nhắn qua Facebook',
  'floating.quickContact': 'Liên hệ nhanh',
  'floating.bookNow': 'Đặt ngay',
  'footer.paymentMethods': 'Phương thức thanh toán',
  'footer.copyright': 'Bản quyền 2026 Vietnam.st - Đã đăng ký bản quyền',
};